import { all, takeLatest, call, put, spawn } from 'redux-saga/effects';
import { APP_ERROR } from '~/constants';
import toast from '~/services/toast';
import history from '~/services/history';
import normalizeError from '~/utils/normalize-error';
import * as authActions from './auth/auth-actions';

import { appSagas } from './app/app-sagas';
import { authSagas } from './auth/auth-sagas';
import { pdvSagas } from './pdv/pdv-sagas';
import { monitorSagas } from './monitor/monitor-sagas';

export function* erroHandler(data) {
  if (!data?.error) {
    return;
  }

  if (data?.error?.message.includes('Network Error')) {
    return;
  }

  const message = normalizeError(data?.error);

  if (data?.error?.response?.status === 401 && !data?.error?.response?.headers?.ignoreheaders) {
    yield put(authActions.logoutRequest());

    yield call(history.push, '/auth/login');
    yield call(toast.warning, message);
  } else {
    yield call(toast.error, message);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(APP_ERROR, erroHandler), spawn(appSagas), spawn(authSagas), spawn(pdvSagas), spawn(monitorSagas)]);
}
